export const REDUCER_NAME = "event";

export const EVENT_TYPES = {
  appointment: "appointment",
  outOfOffice: "outofoffice",
  breakTime: "break_time",
};

/*
 * A text2pay booking sits in pendingPayment until the patient pays the link. It holds
 * the slot like a booked one, so it shows on the calendar — but it is not confirmed,
 * and the staff have to be able to tell the two apart at a glance.
 */
export const APPOINTMENT_STATUSES = {
  booked: "booked",
  pendingPayment: "pending_payment",
};

/*
 * What a held booking is waiting for. Both hold the slot for the same 30 minutes, but
 * a deposit hold asks the patient to pay and a card-capture hold only asks for a card
 * to enrol in the cancellation policy — nothing is owed there.
 */
export const HOLD_TYPES = {
  deposit: "deposit",
  cardCapture: "card_capture",
};

export const ACTION_TYPES = {
  eventTypeChange: `${REDUCER_NAME}/eventTypeChange`,
  isSubmitActiveChange: `${REDUCER_NAME}/isSubmitActiveChange`,
};
